/**
 * @generated SignedSource<<18259bc9226c8224f702b318943bb057>>
 * @relayHash 6d0316ec71aec1f9877a2a0bcbb04b60
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6d0316ec71aec1f9877a2a0bcbb04b60

import { ConcreteRequest } from 'relay-runtime';
export type HealthInformationType = "ALLERGY" | "BODY_MEASUREMENT" | "CONDITION" | "FAMILY_HISTORY" | "GYNAECOLOGY" | "SOCIAL_HISTORY";
export type De_verifyHealthInformationInput = {
  appointmentId: string;
  healthInformationType: HealthInformationType;
  patientId: string;
};
export type deVerifyHealthInformationMutation$variables = {
  input: De_verifyHealthInformationInput;
};
export type deVerifyHealthInformationMutation$data = {
  readonly verifyHealthInformation: {
    readonly verifyHealthInformationOutput: {
      readonly healthInformationLastVerification: {
        readonly healthInformationType: HealthInformationType;
        readonly id: string;
        readonly patientId: string;
        readonly verifiedAt: string | null;
        readonly verifiedBy: string | null;
      };
      readonly healthInformationVerification: {
        readonly appointmentId: number;
        readonly healthInformationType: HealthInformationType;
        readonly id: string;
        readonly patientId: string;
        readonly verifiedAt: string | null;
        readonly verifiedBy: string | null;
      };
    } | null;
  };
};
export type deVerifyHealthInformationMutation = {
  response: deVerifyHealthInformationMutation$data;
  variables: deVerifyHealthInformationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "patientId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "healthInformationType",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "verifiedAt",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "verifiedBy",
  "storageKey": null
},
v6 = [
  {
    "alias": "verifyHealthInformation",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "De_verifyHealthInformationPayload",
    "kind": "LinkedField",
    "name": "de_verifyHealthInformation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "VerifyHealthInformationOutput",
        "kind": "LinkedField",
        "name": "verifyHealthInformationOutput",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "HealthInformationLastVerification",
            "kind": "LinkedField",
            "name": "healthInformationLastVerification",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "HealthInformationVerification",
            "kind": "LinkedField",
            "name": "healthInformationVerification",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appointmentId",
                "storageKey": null
              },
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deVerifyHealthInformationMutation",
    "selections": (v6/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "deVerifyHealthInformationMutation",
    "selections": (v6/*:: as any*/)
  },
  "params": {
    "id": "6d0316ec71aec1f9877a2a0bcbb04b60",
    "metadata": {},
    "name": "deVerifyHealthInformationMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "c63e79c4eb03ec7ebe6d7a52d0bb0033";

export default node;
